import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/eclips/folders'
const plural = 'eclip'
const single = 'eclip'
const folder = 'v1/eclip'

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})

api.create = (type, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}?type=${type}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

api.index  = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, { params })
		.then(handleResponse)
		.catch(handleError) 
}

api.update = (id, payload, options) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${folder}/${id}/folder`, payload, options)
		.then(handleResponse)
		.catch(handleError);
}

api.get = (id, params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`, params)
		.then(handleResponse)
		.catch(handleError) 
}

api.rename = (id, payload) => {
	return axios
	.put(`${apiProvider.BASE_URL}/${url}/${id}`, payload)
	.then(handleResponse)
	.catch(handleError);
}

api.delete = (id) => {
	return axios
			.delete(`${apiProvider.BASE_URL}/${url}/${id}`)
			.then(handleResponse)
			.catch(handleError)
}

export default api
